// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_3bmUA){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_V5y17 .dualColumn_3-FoI{display:flex;align-content:space-between}.nsAddressForm_V5y17 .dualColumn_3-FoI .firstCol_201R3{margin-right:20px}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_3bmUA",
	"nsAddressForm": "nsAddressForm_V5y17",
	"dualColumn": "dualColumn_3-FoI",
	"firstCol": "firstCol_201R3"
};
module.exports = exports;
